import ParentComponent from './components/ParentComponent';

function App() {
  return (
    <ParentComponent />
  );
}

export default App;